import { ActivityType, CardioOrResistance, Level } from '../entities/exercise/exercise';
import { WorkoutSettings } from '../entities/user';

export class GymSchedulingConfig {
    public static readonly cycleTimeInSeconds = 120;
    public static readonly checkInGraceInMinutes = Number(process.env.CHECKIN_GRACE_IN_MINUTES || '10');
    public static readonly timeAfterHomeWorkoutEndToRemoveIncompleteInMS = 30 * 60 * 1000;
    public static readonly anonymizeSettings: WorkoutSettings = {
        level: Level.Intermediate,
        isDefaultDailyMix: false,
        allowBagContact: false,
        cardioOrResistance: CardioOrResistance.Cardio,
        activityType: ActivityType.OtherCardio,
        threeBodyGroups: [],
        equipment: [],
    };

}
